
export default [
    {
        id: 'zuvlukh',
        title: "Зөвлөх багш",
        icon: <i className="fas fa-chalkboard-teacher"></i> ,
        navLink: "/advice/teacher",
    },
];
